import { ChooseNewPassword } from "./panels/ChooseNewPassword"
import { MemberCodesDialog } from "./panels/MemberCodesDialog"
import { MemberSignup } from "./panels/MemberSignup"
import { MyInformation } from "./panels/MyInformation"
import { useAuth } from "./useAuth"

export const AUTH_MODALS = {
  "choose-new-password": ChooseNewPassword,
  "my-information": MyInformation,
  "member-signup-form": MemberSignup,
  "my-codes": MemberCodesDialog,
} satisfies {
  [name: string]: React.ComponentType<any>
}

export type AuthModalName = keyof typeof AUTH_MODALS

export function AuthModals() {
  const auth = useAuth()
  if (!auth.showingModal) return null

  const Modal = AUTH_MODALS[auth.showingModal.name]

  return <Modal {...(auth.showingModal.props as any)} />
}
